<template>
 <div class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
  <p class="mb-0">© 2026 Stay Bright Windows</p>     
 </div>   
</template>